// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"66894d9a","194":"a8bee192","213":"0216ef70","239":"73d5c59a","422":"622ec0fb","461":"b3b1e064","732":"5a3deaac"}[chunkId] + ".chunk.js";
};